import React from "react";
import { Route, Routes } from "react-router-dom";
import SurveyAddPage from "./SurveyAddPage";
import SurveyResultPage from "./SurveyResultPage";
import SurveyListPage from "./SurveyListPage";

const SurveyPage = () => {
  return (
    <>
      <Routes>
        <Route index element={<SurveyListPage />} />
        <Route path="add/:lecture_id" element={<SurveyAddPage />} />
        <Route path="update/:sid" element={<SurveyAddPage />} />
        <Route path="result/:id" element={<SurveyResultPage />} />
      </Routes>
    </>
  );
};

export default SurveyPage;
